import { RouteObject } from "../../interfaces/navigation";
import React from "react";
const LoginRedirect = React.lazy(() => import("./LoginRedirect"));

export const loginRoutes: RouteObject[] = [
    {
        title: "Login",
        path: "/ingresar",
        component: <LoginRedirect/>
    }
];